<template>
  <v-card max-width="460px" class="mx-auto px-2 pb-0 card--group">
    <v-card-title class="p-0 font-weight-bold py-1 px-0 fixTop">
      <div class="d-flex align-center" v-if="status !== 'search'">
        <!-- <img class="pr-5" :src="chargeImage" alt>
        <v-divider inset class="my-2" vertical></v-divider>-->
        <span class="pl-2" style="color: var(--v-white-base);">{{ detail }}</span>
      </div>
      <v-spacer></v-spacer>
      <img src="@/assets/image/monitoring/icon_alert01.png" v-if="dialogStatus === 'E'">
      <img src="@/assets/image/monitoring/icon_alert02.png" v-if="dialogStatus === 'Y'">
      <v-btn icon dark @click="$emit('closeDetailPop')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-actions class="pa-0" v-if="status === 'search'">
      <v-row class="ma-0">
        <v-col class="pr-0 py-0" cols="4">
          <v-select hide-details dense outlined :items="comboItems" v-model="comboSelect"></v-select>
        </v-col>
        <v-col class="pr-0 py-0" cols="6">
          <v-text-field
            @keyup.enter="$emit('siteName', searchParam, comboSelect)"
            v-model="searchParam"
            hide-details
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="py-0" cols="2">
          <v-btn
            min-width="48"
            width="48"
            height="40"
            color="#0784F2"
            @click="$emit('siteName', searchParam, comboSelect)"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-text class="px-1 pb-0 pt-11">
      <v-container class="px-0 pt-2">
        <v-row dense v-for="(item, inx) in list" v-bind:key="'list_' + inx">
          <v-col cols="12">
            <site-info-window-pop id="infoPop" v-show="true" :info-data="item ? item : infoData[0]"></site-info-window-pop>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import SiteInfoWindowPop from '@/components/mobile/SiteInfoDialog'
import day from 'dayjs'
import { getSearchSite } from '@/api/monitoring/monitoring'
import Message from '@/utils/message'
import localStore from '@/utils/localStore'

// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  components: {
    SiteInfoWindowPop
  },
  props: {
    detail: {
      type: String
    },
    list: {
      type: Array
    },
    status: {
      type: String
    },
    text: {
      type: String
    },
    dialogStatus: {
      type: String
    }
  },
  name: 'AsDialog',
  data() {
    return {
      isAdmin: false,
      comboSelect: 'siteNm',
      searchParam: '',
      count: 0,
      infoData: [
        {
          siteId: 'M2189',
          title: '홍성 지정리 지정3호태양광',
          location: '충청남도 홍성군 구항면 지정리 129',
          date: day('2020-11-13T15:00:00.000+0000').format('YYYY년 MM월 DD일'),
          charge: '유료'
        }
      ],
      benched: 3,
      error: require('@/assets/image/monitoring/icon_alert02.png'),
      strange: require('@/assets/image/monitoring/icon_alert01.png')
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.searchParam = this.text
    this.isAdmin = localStore.get('admin')
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  watch: {
    list() {
      if (this.list.length === 0) {
        Message.info('검색 결과가 없습니다.')
      }
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    comboItems() {
      if (this.isAdmin === 'true') {
        return [
          {
            text: '사이트명',
            value: 'siteNm'
          },
          {
            text: '사이트ID',
            value: 'siteId'
          },
          {
            text: '사용자명',
            value: 'userId'
          }
        ]
      } else {
        return [
          {
            text: '사이트명',
            value: 'siteNm'
          },
          {
            text: '사이트ID',
            value: 'siteId'
          }
        ]
      }
    },
    items() {
      return Array.from({ length: this.list.length }, (k, v) => v + 1)
    },
    setBlock() {
      if (this.visible.indexOf(this.sidoCode) !== -1) {
        this.$emit('noImage', true)
        return true
      }
      return false
    },
    chargeImage() {
      if (this.status === 'err') {
        return this.error
      } else if (this.status === 'str') {
        return this.strange
      } else {
        return ''
      }
    },
    tbColor() {
      if (this.stockState === 'D') {
        return 'border:1px solid rgb(193,85,73);'
      } else if (this.stockState === 'J') {
        return 'border:1px solid rgb(81,145,215);'
      } else if (this.stockState === 'G') {
        return 'border:1px solid rgb(42,149,165);'
      } else if (this.stockState === 'M') {
        return 'border:1px solid rgb(107,117,206);'
      }
      return ''
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style  lang="scss" scoped>
.main_card {
  background-color: rgb(76, 88, 112);
  table {
    font-size: 13px;
    width: 100%;
    // font-color: white;
    border-collapse: collapse;
    tr {
      td {
        background-color: rgb(76, 88, 112);
        text-align: center;
        padding: 0px 0px 0px 0px;
      }
      th {
        background-color: rgb(76, 88, 112);
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
      }
    }
  }
}
.fixTop {
  position: fixed;
  width: calc(100% - 56px);
  z-index: 1;
  background-color: var(--v-cardbg-base) !important;
  border-bottom: 1px solid #fff6;
}
</style>
